const DASHBOARD_ONBOARDING_SESSION_KEY =
  "stagepanda.dashboard.onboarding.loginSessionId";
const DASHBOARD_ONBOARDING_DISMISSED_KEY =
  "stagepanda.dashboard.onboarding.dismissed";

const createLoginSessionId = (email?: string | null) => {
  const emailPart = email?.trim().toLowerCase() || "anonymous";
  return `${emailPart}:${Date.now()}`;
};

export const startDashboardOnboardingLoginSession = (
  email?: string | null,
) => {
  try {
    const sessionId = createLoginSessionId(email);
    localStorage.setItem(DASHBOARD_ONBOARDING_SESSION_KEY, sessionId);
    return sessionId;
  } catch {
    return createLoginSessionId(email);
  }
};

export const getDashboardOnboardingDismissedKey = (
  email?: string | null,
) => {
  try {
    let sessionId = localStorage.getItem(DASHBOARD_ONBOARDING_SESSION_KEY);

    if (!sessionId) {
      sessionId = startDashboardOnboardingLoginSession(email);
    }

    return `${DASHBOARD_ONBOARDING_DISMISSED_KEY}:${sessionId}`;
  } catch {
    return `${DASHBOARD_ONBOARDING_DISMISSED_KEY}:storage-unavailable`;
  }
};
